<template>
  <div>
    <div class="wrapper">
      <div class="row">
        <div class="col-lg-12">
          <div id="filters">
            <div class="search col-lg-12 col-md-12">
              <div class="row">
                <div class="col-lg-3 col-md-3 m-t-sm">
                    <v-select
                      placeholder="Clients"
                      :options="f.clients"
                      label="name"
                      index="id"
                      multiple
                      v-model="filters['clients']"
                    ></v-select>
                </div>
                <div class="col-lg-3 col-md-3 m-t-sm">
                  <div class="display-flex">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 side-input-text pretty-input">Completed</div>
                    <input type="date" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" v-model="filters['dateFrom']" placeholder="From">
                    <input type="date" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" v-model="filters['dateTo']" placeholder="To">
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 m-t-sm">
                  <div class="display-flex">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 side-input-text pretty-input">Built</div>
                    <input type="date" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" v-model="filters['builtFrom']" placeholder="From">
                    <input type="date" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" v-model="filters['builtTo']" placeholder="To">
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 m-t-sm">
                  <div class="display-flex">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 side-input-text pretty-input">Deployed</div>
                    <input type="date" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" v-model="filters['deployedFrom']" placeholder="From">
                    <input type="date" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" v-model="filters['deployedTo']" placeholder="To">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 m-t-sm ">
              <button class="btn btn-xs btn-primary" @click="generateReport">Generate</button>
              <button class="btn btn-xs btn-primary" @click="generateReport(true)"><i class="fa fa-download"></i> Csv</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12">
          <h5 v-if="meta">Showing <strong>{{ meta.count }}</strong> results</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>Domain</th>
              <th>Client</th>
              <th>Order</th>
              <th>Built</th>
              <th>Deployed</th>
              <th>Builder</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in rows" :key="row.id">
              <td><router-link :to="'/pbn/' + row.punyDomain">{{ row.domain }}</router-link></td>
              <td>{{ row.client.name }}</td>
              <td>
                <span v-if="row.order">
                  <router-link :to="'/pbn/order/' + row.order.id">{{ row.order.name }}</router-link>
                </span>
                <span v-else>/</span>
              </td>
              <td>
                <span v-if="row.buildActions.built">{{ row.buildActions.built.endTime | aTime('DD.MM.YYYY') }}</span>
              </td>
              <td>
                <span v-if="row.buildActions['site-moved']">{{ row.buildActions['site-moved'].endTime | aTime('DD.MM.YYYY') }}</span>
              </td>
              <td>
                <span v-if="row.buildActions.built && row.buildActions.built.assignee">{{ row.buildActions.built.assignee.name }}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { Browser, Query } from '../../../../mixins/helperMixin'

export default {
  data () {
    return {
      rows: [],
      filters: {},
      meta: false
    }
  },
  mixins: [Query, Browser],
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  methods: {
    generateReport (csv = false) {
      axios.get('/report/build/domain-overview?' + this.buildQuery(this.filters), {
        headers: {
          'Accept': csv === true ? 'text/csv' : 'application/json'
        }
      })
        .then(r => {
          if (csv === true) {
            this.downloadFile('built-sites.csv', r.data.data)
          } else {
            this.rows = r.data.data
            this.meta = r.data.meta
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Reports/Builds.vue